import { MeetingRoomBooking, RoomBookingSource } from "../models/MeetingRooms";

export function IsMeetingRoomBookingFromOutlook(meetingRoomBooking: MeetingRoomBooking): boolean {
  return meetingRoomBooking.source === RoomBookingSource.OUTLOOK ||
    meetingRoomBooking.source === RoomBookingSource.SYSTEM_LINKED_TO_OUTLOOK;
}
